import styled from 'styled-components'
import { Link } from 'react-router-dom'

export const CardContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 230px;
  padding: 10px 20px;
  background: var(--surface-bg);
  height: 265px;
  max-height: 265px;
`

export const RecentlyOpenedContainer = styled.div`
  margin-top: 2rem;
`

export const FavouriteStarContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: flex-end;
  cursor: pointer;
`

export const ApplicationIconContainer = styled(Link)`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 70px;
  max-height: 75px;
  padding-bottom: 10px;
`

export const ApplicationNameContainer = styled.div`
  display: flex;
  font-weight: 500;
  line-height: 20px;
  font-size: 14px;
  color: var(--text-heading);
  justify-content: center;
  flex-direction: column;
  align-items: center;
`

export const Image = styled.img`
  width: 74px;
  height: 74px;
`

export const ApplicationDescriptionContainer = styled.span`
  display: flex;
  justify-content: center;
  align-items: center;
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  color: var(--text-body);
  opacity: 0.7;
  margin: 10px 0;
  height: 40px;
  max-height: 40px;
  overflow: hidden;
`

export const ButtonContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 30px;
`

export const ApplicationName = styled.div`
  font-weight: normal;
  font-size: 14px;
  line-height: 21px;
  color: var(--text-heading);
  font-weight: 900;
  max-height: 40px;
  overflow: hidden;
  text-align: center;
`
